import { httpManager } from './manager'

const apiSparkleSecurity = httpManager.create({ baseURL: process.env.API_SPARKLE_SECURITY })
apiSparkleSecurity.defaults.timeout = 2000

export default apiSparkleSecurity
